import type { ICustomControlProcedureDiagnosticReportReadProps } from '../../interfaces';
import { OsasqV1ProcedureRead } from './OsasqV1ProcedureRead';

export function OsasqV1ProcedureDiagnosticReportRead(props: ICustomControlProcedureDiagnosticReportReadProps) {
    return <OsasqV1ProcedureRead {...props} />;
}
